import { render, staticRenderFns } from "./SurveyProductList.vue?vue&type=template&id=0374893e"
import script from "./SurveyProductList.vue?vue&type=script&lang=js"
export * from "./SurveyProductList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports